import _WidgetBaseSP from 'more/_WidgetBaseSP';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './CreateStageForm.html?raw';



class CreateStageForm extends compose(_WidgetBaseSP) {
    templateString: any = template;

    tableContainer: HTMLDivElement;
    good_node: HTMLDivElement;
    truck_node: HTMLDivElement;
    cargo_hold_node: HTMLDivElement;
 

    //-----------------------own methods -------------------------end
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        this.RequestManager.handleAs = "jsonWithDate";



    }
    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(CreateStageForm);

